import classNames from 'classnames';
import React from 'react';
import Icon from 'shared/components/icon';
import './remove-button.scss';

interface Props {
  onRemove: () => void;
  className?: string;
}

const RemoveButton = ({onRemove, className}: Props) => (
  <button
    className={classNames('shared-remove-button', className)}
    data-testid="shared-remove-button"
  >
    <Icon
      onClick={onRemove}
      iconType="times-r"
      className="shared-remove-button--icon"
      testid="remove-button"
    />
  </button>
);

export default RemoveButton;
